import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronLeftLine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 15,4.25 c -0.191925,0 -0.3848,0.072305 -0.53125,0.21875 l -7,7 c -0.2928897,0.2929 -0.2928897,0.7696 0,1.0625 l 7,7 c 0.2929,0.2929 0.7696,0.2929 1.0625,0 0.2929,-0.2929 0.2929,-0.7696 0,-1.0625 L 9.0605469,12 15.53125,5.53125 c 0.2929,-0.2928897 0.2929,-0.7696103 0,-1.0625 C 15.3848,4.3223051 15.191925,4.25 15,4.25 Z"
	})]
});
export default SvgChevronLeftLine;
